import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/image/question_analysis_icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-b9056a2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "review_content_bg" }
const _hoisted_2 = {
  key: 0,
  class: "review_content"
}
const _hoisted_3 = {
  key: 0,
  class: "prologue_text"
}
const _hoisted_4 = { class: "top_info_content" }
const _hoisted_5 = {
  ref: "problemBgRef",
  class: "problem_bg"
}
const _hoisted_6 = { class: "problem_title" }
const _hoisted_7 = {
  key: 0,
  class: "problem_info_bg"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["onClick", "innerHTML"]
const _hoisted_10 = { class: "problem_info_bg" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "analysis_bg" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "analysis_title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "analysis_icon",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "analysis_title_text" }, "错题解析")
], -1))
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "footer" }
const _hoisted_18 = { class: "lottie_animation_bg" }
const _hoisted_19 = {
  class: "lottie_animation",
  ref: "lottieAnimationRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "scale-transition" }, {
      default: _withCtx(() => [
        (_ctx.showReview)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.showPrologue)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                : (_openBlock(), _createElementBlock("div", {
                    class: "problem_content",
                    key: _ctx.componentKey
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.questionInfo?.qtype == 0 ? '选择题' : '判断题'), 1),
                        (_ctx.questionInfo?.qtype == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("span", {
                                ref: "problemRef",
                                innerHTML: _ctx.questionInfo?.content,
                                class: "problem_info"
                              }, null, 8, _hoisted_8),
                              _createElementVNode("div", {
                                class: _normalizeClass(['options_bg', _ctx.questionInfo?.showAnalysis ? 'options_selected_bg' : ''])
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionInfo?.options, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: _normalizeClass(_ctx.getOptionClass(item)),
                                    onClick: ($event: any) => (_ctx.optionClick(item)),
                                    innerHTML: item.key + '. ' + item.value
                                  }, null, 10, _hoisted_9))
                                }), 256))
                              ], 2)
                            ]))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.questionInfo?.options, (option, index) => {
                              return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("span", {
                                  ref_for: true,
                                  ref: "problemRef",
                                  innerHTML: option.value,
                                  class: "problem_info"
                                }, null, 8, _hoisted_11),
                                _createElementVNode("div", {
                                  class: _normalizeClass(['judge_options_bg', _ctx.questionInfo?.showAnalysis ? 'options_selected_bg' : ''])
                                }, [
                                  _createElementVNode("button", {
                                    class: _normalizeClass(_ctx.getJudgeOptionClass(option, index, 0)),
                                    onClick: ($event: any) => (_ctx.judgeOptionClick(option, index, true))
                                  }, "对", 10, _hoisted_12),
                                  _createElementVNode("button", {
                                    class: _normalizeClass(_ctx.getJudgeOptionClass(option, index, 1)),
                                    onClick: ($event: any) => (_ctx.judgeOptionClick(option, index, false))
                                  }, "错", 10, _hoisted_13)
                                ], 2)
                              ]))
                            }), 256))
                      ], 512),
                      _withDirectives(_createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("span", {
                          ref: "analysisRef",
                          class: _normalizeClass(['analysis_text', _ctx.questionInfo?.showAnalysisD == true ? 'analysis_text_height' : '']),
                          innerHTML: _ctx.questionInfo?.analysis
                        }, null, 10, _hoisted_16)
                      ], 512), [
                        [_vShow, _ctx.questionInfo?.showAnalysis == true]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", {
                        class: "footer_button next_button",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.nextButtonClick && _ctx.nextButtonClick(...args)))
                      }, _toDisplayString(_ctx.questionInfo?.showAnalysis == true ? '学会啦下一个' : '完成啦下一个'), 1)
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, null, 512)
    ], 512), [
      [_vShow, _ctx.showLottieView]
    ]),
    _withDirectives(_createVNode(_component_Loading, null, null, 512), [
      [_vShow, _ctx.showLoading]
    ])
  ]))
}